import React from 'react';
import { Form, Col, Row, Button } from 'react-bootstrap';
import axios, { AxiosRequestConfig } from 'axios';
import { Constants } from "../../constants";
import ContractorMenu from "../contractor_menu";
import moment from 'moment';
import '../../App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import ReactGA from "react-ga4";

class ContractorAddFromBid extends React.Component {
    constructor(props) {
        super(props);

        let userExists = !(props.location.state == null || props.location.state.user == null);
        this.state = {
            user: userExists ? props.location.state.user : {},
            contractor: props.location.state.contractor,
            userExists: userExists,
            input: {
                contractorName: props.location.state.contractor.Name,
                username: props.location.state.user.username,
                userEmail: props.location.state.user.email,
                contractorEmail: props.location.state.contractor.ContactEmail,
                jobName: props.location.state.job.JobName,
                bidDate: props.location.state.job.BidDate,
                notes: ''
            },
            job: props.location.state.job,
            errors: {}
        };

        /*this.createSelectItems = this.createSelectItems.bind(this);*/
        this.handleFormChange = this.handleFormChange.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.fileControl = React.createRef();
        this.handleSubmit = this.handleSubmit.bind(this);
    }


    handleFormChange(event) {
        let input = this.state.input;
        let errors = this.state.errors;

        if (event.target.type == 'checkbox') {
            input[event.target.name] = !input[event.target.name];
        }
        else {
            input[event.target.name] = event.target.value;
        }

        if (!!errors[event.target.name]) {
            errors[event.target.name] = null;
        }

        this.setState({
            input,
            errors
        });
    }

    validate() {
        let input = this.state.input;
        let errors = {};
        let isValid = true;


        if (!input["jobName"]) {
            isValid = false;
            errors["jobName"] = "Please enter your first name.";
        }
        if (!input["bidDate"]) {
            isValid = false;
            errors["bidDate"] = "Please enter your last name.";
        }

        this.setState({
            errors: errors
        });

        return isValid;
    }

    handleCancel(event) {
        this.props.history.goBack();
    }

    handleSubmit(event) {

        event.preventDefault();
        if (!this.validate()) {
            alert('Please fill in required fields to proceed.');
            return;
        }
        this.setState({ loading: true });

        let formData = new FormData();
        for (var key in this.state.input) {
            formData.append(key, this.state.input[key]);
        }
        for (var key in this.state.user) {
            formData.append(key, this.state.user[key]);
        }
        for (var i = 0; i < this.fileControl.current.files.length; i++) {
            formData.append('attachments', this.fileControl.current.files[i]);
        }

        formData.append('contractorId', this.state.contractor.Id);
        formData.append('opportunityId', this.state.job.Id);

        axios.post(`${Constants.apiURL}/api/Contractor/AddToBid`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        }).then(response => {
            if (response.data && response.data == true) {
                ReactGA.event({
                    category: 'Contractor',
                    action: 'Add to bid list',
                    label: 'Contractor'
                });
                alert('Thank you! We have received your request, and a confirmation email will be delivered to you shortly. We will reach out with any questions.');

                this.props.history.goBack();
            }
            else {
                alert('Error processing your request');
            }
            this.setState({ loading: false });
        }).catch((response) => {
            // ? Show to user that request is failed
            this.setState({ errors: [response] })
            this.setState({ loading: false });
            console.log('request failed', response)
        });

    }

    render() {
        return (
            <div>
                <ContractorMenu user={this.state.user} contractor={this.state.contractor}  currentPage='contractorAddToJob' />
                <Form onSubmit={this.handleSubmit} noValidate>
                    <div>
                        <Row style={{ paddingLeft: '12px' }}>
                            <Col>
                                <Form.Label style={{
                                    paddingBottom: 0, marginBottom: 0, verticalAlign: 'middle', fontWeight: 'bold', fontSize: '24px', color: '#1F419B', paddingTop: '10px'
                                }}>
                                    ADD TO BID LIST FORM</Form.Label>
                            </Col>
                            <Col style={{ flex: .5, textAlign: 'right' }}>
                                <Form.Label style={{
                                    paddingBottom: 0, marginBottom: 0, paddingRight: '10px', verticalAlign: 'middle', fontWeight: 'bold', fontSize: '21px', color: '#1F419B', paddingTop: '10px'
                                }}>
                                    {this.state.contractor.Name}</Form.Label>
                            </Col>
                        </Row>
                        <Row style={{ margin: 5 }} >
                            <Col md={6}>
                                <Form.Group as={Row} className="mb-3" >
                                    <Form.Label column md={2} >Job name</Form.Label>
                                    <Col md={10}>
                                        <Form.Control type="input" name="jobName" value={this.state.job.JobName} onChange={this.handleFormChange} disabled />
                                    </Col>
                                </Form.Group>
                                <Form.Group as={Row} className="mb-3" >
                                    <Form.Label column md={2} >Bid Date</Form.Label>
                                    <Col md={4}>
                                        <Form.Control type="date" min={moment().format('yyyy-MM-DD')} name="bidDate" value={this.state.job.BidDate} onChange={this.handleFormChange}
                                            disabled />
                                    </Col>
                                </Form.Group>
                                <Form.Group as={Row} className="mb-3" >
                                    <Form.Label column md={2} >Notes (optional):</Form.Label>
                                    <Col md={10}>
                                        <Form.Control as="textarea" rows={3} name="notes" value={this.state.input.notes} onChange={this.handleFormChange} />
                                    </Col>
                                </Form.Group>
                                <Form.Group as={Row} controlId="formAttachment" className="mb-3">
                                    <Form.Label column md={2} >Attachments</Form.Label>
                                    <Col md={10}>
                                    <Form.Control type="file" ref={this.fileControl} multiple />
                                    </Col>
                                </Form.Group>
                            </Col>
                        </Row>
                    </div>
                </Form>
                <Button style={{ marginLeft: '10px', backgroundColor: '#1F419B' }} variant="primary" type="submit" onClick={this.handleSubmit}>
                    Add us to Bid List
                </Button>
                <Button style={{ marginLeft: '10px' }} variant="secondary" type="button" onClick={this.handleCancel}>
                    Cancel
                </Button>
            </div>
        );
    }
}

export default ContractorAddFromBid;